import apiConfig from '../api-config';

// Mini routeur API interne
export default {
  getPrefix() {
    return apiConfig.getConfig().localUrl;
  },
  getMainEntryPoint() {
    return '/wp-json/cgad/v1';
  },
  generate(slug, params) {
    switch(slug) {
      case 'searchJob': {
        if (typeof params.family !== 'undefined') {
          return this.getPrefix() + this.getMainEntryPoint() + '/search-job/' + params.family;
        }
        break;
      }
      case 'searchEtude': {
        if (typeof params.type !== 'undefined') {
          return this.getPrefix() + this.getMainEntryPoint() + '/search-etude/' + params.type;
        }
        break;
      }
      case 'searchFormation': {
          return this.getPrefix() + this.getMainEntryPoint() + '/search-formation/';
      }
      case 'family': {
        if (typeof params.familySlug !== 'undefined') {
          return this.getPrefix() + '/family/' + params.familySlug;
        }
        break;
      }
    }
    return '';
  },
}



// WEBPACK FOOTER //
// ./scripts/util/local-api-routes.js